import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import LanguageForm from '../../../components/forms/LanguageForm';
import { useUpdateLanguage, useLanguageById } from '../../../hooks/useLanguageApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { LanguageDTO } from '../../../services/apiClient';

const LanguageEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useLanguageById(id!);
  const updateLanguage = useUpdateLanguage();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Languages', href: '/admin/languages' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    updateLanguage.mutate({ id: id!, data }, {
      onSuccess: () => {
        navigate('/admin/languages');
      },
      onError: (error) => {
        console.error('Error updating Language:', error);
      },
    });
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/languages"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.Language.Edit"
    >
        {entityData ? (
          <LanguageForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/languages')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default LanguageEdit;
